const resolveSiteUrl = (): string => {
  if (process.env.REACT_APP_SITE_URL) return process.env.REACT_APP_SITE_URL;
  if (process.env.SITE_URL) return process.env.SITE_URL;
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
};

const normalizeBaseUrl = (url: string): string => {
  if (!url) return '';
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

const baseSiteUrl = normalizeBaseUrl(resolveSiteUrl());

const defaultRedirect = baseSiteUrl
  ? `${baseSiteUrl}/auth/callback`
  : '/auth/callback';

export const EMAIL_REDIRECT_TO =
  process.env.REACT_APP_EMAIL_REDIRECT_TO || defaultRedirect;
